import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AboutPage } from './about/AboutPage';
import { CITIES } from './city/cities';
import { CityPage } from './city/CityPage';
import { MarketingPage } from './MarketingPage';
import { PartnersPage } from './partners/PartnersPage';
import { InvitePage } from './invite/InvitePage';
import { DailyPromptPage } from './prompt/DailyPromptPage';
import { PromptsArchivePage } from './prompt/PromptsArchivePage';
import { PrivacyPolicyPage } from './legal/PrivacyPolicyPage';
import { HelpCenterPage } from './legal/HelpCenterPage';
import { ChildSafetyPage } from './legal/ChildSafetyPage';
import { CommunityGuidelinesPage } from './legal/CommunityGuidelinesPage';
import { DeleteAccountPage } from './legal/DeleteAccountPage';
import { PrivacyChoicesPage } from './legal/PrivacyChoicesPage';
import { TermsOfServicePage } from './legal/TermsOfServicePage';
import { LicensesPage } from './legal/LicensesPage';
import { SafetyPolicyPage } from './legal/SafetyPolicyPage';

/**
 * The route table on its own, with no router around it. The browser wraps it in BrowserRouter;
 * the prerender (entry-server.tsx) wraps the same tree in StaticRouter, which is what keeps the
 * shipped HTML and the first client render identical.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      {/* Door campaign landings — same page, door-emphasized hero (marketingDoorHeroes). */}
      <Route path="/for-him" element={<MarketingPage door="him" />} />
      <Route path="/for-her" element={<MarketingPage door="her" />} />
      <Route path="/open-minded" element={<MarketingPage door="open" />} />
      <Route path="/about" element={<AboutPage />} />
      {/* Businesses applying to be a suggested meetup spot. /for-business is the friendlier
            thing to say out loud or print, so it redirects rather than being a second page. */}
      <Route path="/partners" element={<PartnersPage />} />
      <Route path="/invite" element={<InvitePage />} />
      <Route path="/for-business" element={<Navigate to="/partners" replace />} />
      {/* City pages: one per metro the beta opens, from src/city/cities.ts. */}
      <Route path="/austin" element={<CityPage city={CITIES.austin} />} />
      {/* One question a day, and the whole bank behind it. */}
      <Route path="/prompt" element={<DailyPromptPage />} />
      <Route path="/prompts" element={<PromptsArchivePage />} />
      <Route path="/legal/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/legal/community-guidelines" element={<CommunityGuidelinesPage />} />
      <Route path="/legal/help-center" element={<HelpCenterPage />} />
      <Route path="/legal/terms-of-service" element={<TermsOfServicePage />} />
      <Route path="/legal/licenses" element={<LicensesPage />} />
      <Route path="/legal/safety-policy" element={<SafetyPolicyPage />} />
      <Route path="/safety-policy" element={<Navigate to="/legal/safety-policy" replace />} />
      <Route path="/child-safety" element={<ChildSafetyPage />} />
      <Route path="/legal/delete-account" element={<DeleteAccountPage />} />
      <Route path="/delete-account" element={<Navigate to="/legal/delete-account" replace />} />
      <Route path="/privacy-choices" element={<PrivacyChoicesPage />} />
      <Route
        path="/legal/child-safety-standards"
        element={<Navigate to="/child-safety" replace />}
      />
      <Route path="/child-safety-standards" element={<Navigate to="/child-safety" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
